import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11739b34"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = {
  class: "DialogSection FlexColumn",
  style: {"width":"60%","flex":"auto"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_9 = {
  key: 0,
  style: {"display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_10 = {
  key: 1,
  class: "CookiesDialogFooter"
}
const _hoisted_11 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.Access(_ctx.DialogData.Editing ? 'HR_PayrollItems_Edit': 'HR_PayrollItems_Create'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: 'CookiesDialog_' + _ctx.DialogIndex,
          class: "CookiesDialogdBody"
        }, [
          (_ctx.Saving)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.Loading.length > 0)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Type'),
                    Default: '',
                    Options: _ctx.PayrollItemType,
                    Selectors: ['Name'],
                    CookiesInvalidInput: !_ctx.MEMRead('D_PayrollItem_Type') && _ctx.MEMRead('D_PayrollItem_Type') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_PayrollItem_Type') && _ctx.MEMRead('D_PayrollItem_Type') === ''),
                    Res: 'D_PayrollItem_Type'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Position Name'),
                    Default: '',
                    Options: _ctx.Positions,
                    RowHeight: '3em',
                    Selectors: [['Name'], ['Department', 'Name']],
                    CookiesInvalidInput: !_ctx.MEMRead('D_PayrollItem_Position') && _ctx.MEMRead('D_PayrollItem_Position') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_PayrollItem_Position') && _ctx.MEMRead('D_PayrollItem_Position') === ''),
                    Res: 'D_PayrollItem_Position'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Employee Name'),
                    Default: '',
                    Options: _ctx.Employees,
                    RowHeight: '3em',
                    Selectors: [['Name'], ['ID']],
                    CookiesInvalidInput: !_ctx.MEMRead('D_PayrollItem_Employee') && _ctx.MEMRead('D_PayrollItem_Employee') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_PayrollItem_Employee') && _ctx.MEMRead('D_PayrollItem_Employee') === ''),
                    Res: 'D_PayrollItem_Employee'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDescriptionBox, {
                    Placeholder: _ctx.Translate('Reason'),
                    Res: 'D_PayrollItem_Reason'
                  }, null, 8, ["Placeholder"])
                ])
              ]),
              _hoisted_7,
              _hoisted_8,
              (_ctx.MEMRead('D_PayrollItem_Type_Value')?.IsCustomizable == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_CookiesNumberInput, {
                      Step: 0.01,
                      MinWidth: '3em',
                      Name: 'Percentage',
                      Unit: '%',
                      CookiesInvalidInput: !_ctx.MEMRead('D_PayrollItem_Percentage') && _ctx.MEMRead('D_PayrollItem_Percentage') === '',
                      ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_PayrollItem_Percentage') && _ctx.MEMRead('D_PayrollItem_Percentage') === ''),
                      Res: 'D_PayrollItem_Percentage',
                      Default: _ctx.MEMRead('D_PayrollItem_Type_Value')?.Percentage,
                      DefaultReset: true
                    }, null, 8, ["CookiesInvalidInput", "ErrorData", "Default"]),
                    _createVNode(_component_CookiesNumberInput, {
                      Step: 5,
                      MinWidth: '3em',
                      Name: 'Fixed',
                      Unit: _ctx.PriceUnit,
                      CookiesInvalidInput: !_ctx.MEMRead('D_PayrollItem_Fixed') && _ctx.MEMRead('D_PayrollItem_Fixed') === '',
                      ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_PayrollItem_Fixed') && _ctx.MEMRead('D_PayrollItem_Fixed') === ''),
                      Res: 'D_PayrollItem_Fixed',
                      Default: _ctx.MEMRead('D_PayrollItem_Type_Value')?.Fixed,
                      DefaultReset: true
                    }, null, 8, ["Unit", "CookiesInvalidInput", "ErrorData", "Default"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.Access(_ctx.DialogData.Editing ? 'HR_PayrollItems_Edit': 'HR_PayrollItems_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              class: "F-Bold CookiesButton DialogFooterButton BGMain"
            }, _toDisplayString(_ctx.Translate('Save')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}